// extracted by mini-css-extract-plugin
export default {"download-speed-container":"styles_download-speed-container__VoG62","text-container":"styles_text-container__TWAV3"};